import * as types from '@/store/mutation-types';
import actions from '@/store/actions/contractActions';
import localStorage from '@/components/Services/storage';

function removeTvAndInternet(value, index, arr) {
    return value.isMobile;

    /*
    if (value.isMobile) {
        arr.splice(index, 1);
        return true;
    }

    return false;
    */
}

/**
 * Define the module state
 *
 * @type {object}
 */
const moduleState = {
    clickedContract: {},
    contracts: [],
    phoneNumber: '',
    contractType: '',
};

const mutations = {
    [types.SET_USER_CONTRACTS](state, userData) {
        //userData.contracts = userData.contracts.filter(removeTvAndInternet);
        state.contracts = userData.contracts;
        if (!Object.keys(state.clickedContract).length) {
            const savedId = localStorage.get('selectedContractId', true);
            const saved = savedId ? userData.contracts.find(c => c.contractId === savedId) : null;
            state.clickedContract = saved || userData.contracts[0];
        }
    },

    [types.SET_CLICKED_CONTRACT](state, userData) {
        state.clickedContract = userData.contract;
    },

    [types.CLEAR_CONTRACT_DATA](state) {
        state.clickedContract = {};
        state.contracts = [];
        state.phoneNumber = '';
        state.contractType = '';
    },
};

/**
 * Define the module getters
 *
 * @type {object}
 */
const getters = {
    contract: (state) => state,
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: moduleState,
};
